import React, { Component } from 'react';
import { connect } from 'react-redux';
import { do_action } from '../../actions';
import {getFloor, convertPrice, formartDate, calculatorPriceItem} from '../../utils/convert'
import {BASE_URL_ADMIN} from '../../data/config'
import QuoteDetailItem from './QuoteDetailItem'
import QuoteContractorDetail from './QuoteContractorDetail'
import AdvertVendor from '../Common/AdvertVendor'

class QuotesDetail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            allRoomQuote: [],
            vouchers: [],
            total_price: 0,
            dataPriceItems: {},
            dataAreaItems: {},
            quote: '',
            itemEdit: '',
            priceItemContractor: {},
            priceItemEdit: {},
            room_idx: 0,
            itemIdx: 0,
            nb_add: 1,
            roomAdd: '',
            quoteState: -1,
            designerLoad: false,
            quoteDesignerItems: [],
            duration: '',
            data_duration: {
                duration: '',
                total_price: ''
            }
        }
    }

    componentWillMount() {
        let { match, vendor, history } = this.props;
        let { quote_id } = match.params;
        if (!quote_id) {
            return history.push('/quotes');
        }

        do_action('get_quote_by_id', { id: quote_id })
            .then(data => {
                if (data.signal) {
                    let dataQuote = data.data;
                    this.setState({
                        quote: dataQuote
                    })
                }
            })
            .catch(err => console.log(err));

        if (vendor._id) {
            this.checkVendorState(quote_id, vendor._id);
        }

        do_action('get_vouchers_by_quote', { quote: quote_id })
            .then(res => {
                console.log(res);
                if (res.code != "SUCCESS") return false;
                if (res.data) {
                    var vouchers = res.data;
                    this.setState({
                        vouchers: vouchers
                    });
                }
            })
            .catch(err => {
                this.setState({
                    loading: false
                })
            });     
    }
    renderVoucher(){
        return this.state.vouchers.map((item, idx) => {
            var image = (item.exclusivePhoto && item.exclusivePhoto.image) ? BASE_URL_ADMIN + item.exclusivePhoto.image : '/images/supplier-voucher.jpg';
            var name = (item.supplier && item.supplier.name) ? item.supplier.name : '';
            var counter = item.counter ? item.counter : 0;
            return(
                <div className="item-voucher" key={`voucher-${idx}`}>
                    <div className="col-info">
                        <div className="stt">{ idx + 1 }</div>
                            <div className="image">
                            <img src={ image }/>
                            </div>
                        <div className="stt">{ name }</div>
                    </div>
                    <div className="col-cap">x{counter}</div>
                </div>
            )
        });
    }
    componentWillReceiveProps(nextProps) {
        if (nextProps.vendor && (!this.props.vendor || (this.props.vendor && nextProps.vendor._id != this.props.vendor._id))) {
            let vendor_id = nextProps.vendor._id;
            let type = nextProps.vendor.type;
            let { match } = nextProps
            let { quote_id } = match.params

            this.checkVendorState(quote_id, vendor_id);
        }
    }

    checkVendorState(quote, vendor_id) {
        do_action('check_quote_vendor_state', { quotes: quote, vendor: vendor_id })
            .then(data => {
                if (data.signal) {
                    this.setState({
                        quoteState: data.data
                    });
                } else {
                    console.log(data);
                }
            })
            .catch(err => console.log(err));
    }

    downloadImage(allImage) {
        allImage.forEach((url, idx) => {
            window.downloadImage(url, idx)
        })
    }

    acceptQuotes = (e) => {
        e.preventDefault()

        // console.log('111111111111111111111111111111')
        // return;

        let { vendor } = this.props;
        let { quote, data_duration } = this.state;
        if (window.confirm('Are you sure to accept this quote?')) {
            // if (vendor.type == 'pm' && (!data_duration.duration || !data_duration.total_price)) {
            //     return alert('Please fill information Total Price and Estimated Duration')
            // }

            do_action('vendor_accept_quote', { quotes: quote._id, vendor: vendor._id, duration: data_duration.duration, total_price: data_duration.total_price })
                .then(result => {
                    if (result.signal) {
                        this.setState({
                            quoteState: 1
                        })
                    }
                })
                .catch(err => console.log(err));
        }
    }

    declineQuotes = (e) => {
        e.preventDefault()
        let { vendor } = this.props;
        let { quote } = this.state;
        if (window.confirm('Are you sure to decline this quote?')) {
            do_action('vendor_decline_quote', { quotes: quote._id, vendor: vendor._id })
                .then(result => {
                    if (result.signal) {
                        this.setState({
                            quoteState: -1
                        })
                    }
                })
                .catch(err => console.log(err));
        }
    }

    renderThumbnail = (source) => {
        let numberImage = source.length
        return source.map((item, idx) => {
            if (idx < numberImage - 1) {
                return <li key={`image_${item}`}><a><img className="thumbnail-quote" src={`${item}`} alt="" /></a></li>
            } else {
                return (
                    <li key={`image_${item}`}>
                        <a href="#"><img className="thumbnail-quote" src={`${item}`} alt="" /></a>
                        <div className="last-down" onClick={this.downloadImage.bind(this, source)}>
                            <div><span className="fa fa-cloud-download icon"></span></div>
                            Download All
                        </div>
                    </li>
                )
            }
        })
    }

    printQuotes(e) {
        e.preventDefault()
        let {vendor} = this.props
        let { quote } = this.state;
        if (vendor.type == 'contractor') {
            // this.refs.quoteContractor.printQuotes()
            window.open(`${BASE_URL_ADMIN}/api/pdf/vendor/print?quote=${quote._id}&vendor=${vendor._id}`, '_blank')
        } else if (vendor.type == 'designer') {
            window.open(`${BASE_URL_ADMIN}/api/pdf/designer/print?quote=${quote._id}&vendor=${vendor._id}`, '_blank')
        } else {
            window.open(`${BASE_URL_ADMIN}/api/pdf/pm/print?quote=${quote._id}&vendor=${vendor._id}`, '_blank')
        }
    }

    downloadQuotes(e) {
        e.preventDefault()
        let { quote } = this.state;
        let {vendor} = this.props
        if (vendor.type == 'contractor') {
            window.open(`${BASE_URL_ADMIN}/api/pdf/download?quote=${quote._id}&vendor=${vendor._id}`, '_blank')
        } else if (vendor.type == 'designer') {
            window.open(`${BASE_URL_ADMIN}/api/pdf/designer/download?quote=${quote._id}&vendor=${vendor._id}`, '_blank')
        } else {
            window.open(`${BASE_URL_ADMIN}/api/pdf/pm/download?quote=${quote._id}&vendor=${vendor._id}`, '_blank')
        }
    }

    renderQuoteImage() {
        let {vendor} = this.props
        let {type} = vendor

        type = (type == 'pm') ? 'manager' : type;

        let { quote } = this.state;
        if (!quote) return '';
        return (
            <div className="col-xs-12 col-sm-12 col-md-5 col-lg-4">
                <div className="side-a">
                    <div className="title">Action</div>
                    <ul className="list-inline list-img list-download">
                        {this.renderThumbnail(quote.image)}
                    </ul>
                    <ul className="list-unstyled list-info">
                        <li className="clearfix">
                            <span className="info-name">House type</span>
                            <span className="info-value">{quote.house_type}</span>
                        </li>
                        <li className="clearfix">
                            <span className="info-name">Area</span>
                            <span className="info-value">{quote.areas}</span>
                        </li>
                        <li className="clearfix">
                            <span className="info-name">New or resale</span>
                            <span className="info-value">{quote.state}</span>
                        </li>
                        <li className="clearfix">
                            <span className="info-name">Expected date</span>
                            <span className="info-value">{formartDate(quote.expected_date)}</span>
                        </li>
                    </ul>
                    <div className="continue-border">
                        {this.renderRoleButton()}
                        <div className="clearfix group2a">
                            <a href="#" className="left" onClick={this.downloadQuotes.bind(this)}>
                                <span className="fa fa-cloud-download "></span>
                            </a>
                            <a href="#" className="right" onClick={this.printQuotes.bind(this)}>
                                <span className="fa fa-print"></span>
                            </a>
                        </div>
                    </div>
                </div>
            
                <AdvertVendor ps={type}/>

                <div className="side-a vouchers">
                    <div className="title">Voucher</div>
                    <div className="list-voucher">
                        {this.renderVoucher()}  
                    </div>
                </div>
            </div>
        );
    }

    renderRoleButton = () => {
        let { quoteState } = this.state;
        if (quoteState === 0) return (<div>
            <a href="#" className="continue bg-blue" onClick={this.acceptQuotes.bind(this)}>Accept</a>
            <a href="#" className="cancel" onClick={this.declineQuotes.bind(this)}>Decline</a></div>);
        if (quoteState === 2) return (<div>
            </div>);
        if (quoteState === -1) return (<div>
            <a className="cancel">You've declined this quote</a></div>);
        if (quoteState === 1) return (<a className="cancel">You've accepted this quote</a>);
    }

    setDuration = (data_duration) => {
        this.setState({
            data_duration
        })
    }

    render() {
        let { match, vendor, history } = this.props;
        let { quote_id } = match.params;
        if (!vendor._id) return ''
        return (
            <div className="col-sm-9 col-sm-offset-3 col-md-10 col-md-offset-2 maindb">
                <div className="form-group clearfix">
                    <div className="pull-left">
                        <h3 className="marginT0">Quote Detail</h3>
                    </div>
                </div>

                <div className="form-group">
                    <div className="row">
                        <div className="col-xs-12 col-sm-12 col-md-7 col-lg-8">
                            {vendor.type == 'contractor' ? (
                                <QuoteContractorDetail 
                                    vendor={vendor}
                                    quote={quote_id}
                                    quoteState={this.state.quoteState}
                                    ref='quoteContractor'
                                />
                            ) : (
                                <QuoteDetailItem 
                                    vendor={vendor}
                                    quote={quote_id}
                                    quoteState={this.state.quoteState}
                                    setDuration={this.setDuration}
                                    ref="quoteOther"
                                />
                            )}
                        </div>

                        {this.renderQuoteImage()}

                    </div>
                </div>

            </div>
        );
    }
}

function mapStateToProps(state) {
    const { vendor } = state;
    return {
        vendor
    }
}

export default connect(mapStateToProps)(QuotesDetail);